import {
    CONFIRMED_GET_HOW_TO_TAKES,
    CONFIRMED_CREATE_HOW_TO_TAKE,
    CONFIRMED_DELETE_HOW_TO_TAKE,
    CONFIRMED_EDIT_HOW_TO_TAKE,
  } from "../types/HowToTakeTypes";
  
  const initialState = {
    list: [],
    num_rows: 0,
  };
  
  export default function HowToTakeReducer(state = initialState, action) {
    switch (action.type) {
      case CONFIRMED_GET_HOW_TO_TAKES:
        return {
          ...state,
          list: action.payload.list,
          num_rows: action.payload.num_rows,
        };
  
      case CONFIRMED_CREATE_HOW_TO_TAKE:
        return {
          ...state,
          list: [...state.list, action.payload],
        };
  
      case CONFIRMED_DELETE_HOW_TO_TAKE:
        return {
          ...state,
          list: state.list.filter(
            (item) =>
              item.how_to_take_id !== action.payload.how_to_take_id
          ),
        };
  
      case CONFIRMED_EDIT_HOW_TO_TAKE:
        const updatedList = [...state.list];
        const index = updatedList.findIndex(
          (item) =>
            item.how_to_take_id === action.payload.how_to_take_id
        );
  
        if (index !== -1) {
          updatedList[index] = action.payload;
        }
  
        return {
          ...state,
          list: updatedList,
        };
  
      default:
        return state;
    }
  }
  